import React, { useState } from 'react';


function TimeSelectionModal({ onClose, onConfirm }) {
  // Keep track of which option is selected
  const [selectedTime, setSelectedTime] = useState('');

  // Handle confirmation
  const handleConfirm = () => {
    // Send the chosen time to the parent
    onConfirm(selectedTime);
    // Then close the modal
    onClose();
  };

  // Close modal if user clicks the dark overlay (optional)
  const handleOverlayClick = (e) => {
    if (e.target.id === 'time-modal-overlay') {
      onClose();
    }
  };

  return (
    <div
      id="time-modal-overlay"
      onClick={handleOverlayClick}
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 rounded-xl shadow-lg max-w-xl mx-auto w-full"
      >
        <h2 className="text-2xl font-semibold font-title mb-6">
          Выберите удобное время для звонка
        </h2>
        <div className="flex flex-col space-y-4 mb-6">
          {/* Option 1 */}
          <label className="flex items-center space-x-2 text-lg">
            <input
              type="radio"
              name="timeOption"
              value="В ближайшее время"
              className='w-6 h-6'
              checked={selectedTime === 'В ближайшее время'}
              onChange={() => setSelectedTime('В ближайшее время')}
            />
            <span>В ближайшее время</span>
          </label>

          {/* Option 2 */}
          <label className="flex items-center space-x-2 text-lg">
            <input
              type="radio"
              name="timeOption"
              className='w-6 h-6'
              value="с 9:00 до 12:00"
              checked={selectedTime === 'с 9:00 до 12:00'}
              onChange={() => setSelectedTime('с 9:00 до 12:00')}
            />
            <span>с 9:00 до 12:00</span>
          </label>

          {/* Option 3 */}
          <label className="flex items-center space-x-2 text-lg">
            <input
              type="radio"
              name="timeOption"
              className='w-6 h-6'
              value="с 12:00 до 16:00"
              checked={selectedTime === 'с 12:00 до 16:00'}
              onChange={() => setSelectedTime('с 12:00 до 16:00')}
            />
            <span>с 12:00 до 16:00</span>
          </label>

          {/* Option 4 */}
          <label className="flex items-center space-x-2 text-lg">
            <input
              type="radio"
              name="timeOption"
              className='w-6 h-6'
              value="с 16:00 до 20:00"
              checked={selectedTime === 'с 16:00 до 20:00'}
              onChange={() => setSelectedTime('с 16:00 до 20:00')}
            />
            <span>с 16:00 до 20:00</span>
          </label>
        </div>

        <button
          onClick={handleConfirm}
          disabled={!selectedTime} // disable if user hasn't chosen anything
          className="px-8 py-3 bg-[#FF4548] text-white rounded-full w-full hover:bg-black hover:border-[#FF4548] border border-black transition-all duration-300 ease-in-out"
        >
          Подтвердить
        </button>
      </div>
    </div>
  );
}

export default TimeSelectionModal;